import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { Injector } from '@angular/core';
import { IContentLanguageLabelModel } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { ICreateChangeBase } from '@fi-shared/models/models';

export interface IBusinessAreaModel extends ICreateChangeBase {
    Id?: number;
    Name?: string;
    Description?: string;
    IsSystemObject?: boolean;
    Names?: IContentLanguageLabelModel[];
    Descriptions?: IContentLanguageLabelModel[];
    TotalBusinessUnitsCount?: number;
    ActiveBusinessUnitsCount?: number;
    UsersCount?: number;
}

export class BusinessAreaModel {
    Id = 0;
    Name = '';
    Description = '';
    CreatedByUserId = 0;
    CreatedByUserName = '';
    CreatedOn: string; //ISO 8601 date
    ChangedByUserId = 0;
    ChangedByUserName = '';
    ChangedOn: string; //ISO 8601 date
    Names: IContentLanguageLabelModel[] = [];
    Descriptions: IContentLanguageLabelModel[] = [];
    TotalBusinessUnitsCount = 0;
    ActiveBusinessUnitsCount = 0;
    UsersCount = 0;
    IsSystemObject = false;

    constructor(businessArea: IBusinessAreaModel, injector: Injector) {
        this.Initialize(businessArea, injector);
    }

    Initialize(businessArea: IBusinessAreaModel, injector: Injector) {
        if (businessArea) {
            this.Id = businessArea.Id;
            this.Name = businessArea.Name;
            this.Description = businessArea.Description;
            this.CreatedByUserId = businessArea.CreatedByUserId;
            this.CreatedByUserName = businessArea.CreatedByUserName;
            this.CreatedOn = businessArea.CreatedOn;
            this.ChangedByUserId = businessArea.ChangedByUserId;
            this.ChangedByUserName = businessArea.ChangedByUserName;
            this.ChangedOn = businessArea.ChangedOn;
            this.IsSystemObject = businessArea.IsSystemObject || false;
            this.TotalBusinessUnitsCount = businessArea.TotalBusinessUnitsCount;
            this.ActiveBusinessUnitsCount = businessArea.ActiveBusinessUnitsCount;
            this.UsersCount = businessArea.UsersCount;
        }
        const contentLanguagesService = injector.get(ContentLanguagesService);
        contentLanguagesService.InitializeContentLanguagesArray(
            this.Names,
            businessArea ? businessArea.Names : [],
            true,
        );
        contentLanguagesService.InitializeContentLanguagesArray(
            this.Descriptions,
            businessArea ? businessArea.Descriptions : [],
            true,
        );
    }
}
